let currentLang = 'en';
let prevMountedUrl = null;
const configuration = {
  languages: [currentLang],
  blacklistedRoutes: ['/mini-iframe'],
};

const getUrlLang = (path, languages) => {
  return path.split('/').find((segment) => languages.includes(segment));
};

const postMessage = (value, type = 'iframe') => {
  if (type === 'iframe-navigation') {
    console.log({ type, value }); // TODO temporarily, for debugging only
  }
  try {
    window.frames.target.postMessage(
      {
        type,
        value,
      },
      '*', // @todo use config.get(currentHost) later
    );
  } catch (e) {
    console.error(e);
  }
};

const mount = (id, inputUrl, onLoadCallback = () => {}, attributes = {}) => {
  const defaultAttributes = {
    frameBorder: 0,
    id: 'betbook',
    class: 'betbook',
    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
  };
  const prevPath = module.getData('path');
  const prevQuery = module.getData('query');
  const [url, query = ''] = inputUrl.split('?');
  let fullQuery = '';
  if (query) {
    fullQuery = '?' + query;
  }
  let iframeUrl = url + fullQuery;
  /** take lang from iframe url */
  currentLang = getUrlLang(url, configuration.languages);

  const prefixedOrigin = window.origin + '/' + configuration.urlPrefix;
  const hasSearchParams = window.location.href.indexOf('?') > 0;
  const indexEnd = hasSearchParams
      ? window.location.href.indexOf('?')
      : window.location.href.length;
  let path = prevPath || window.location.href.substring(
    prefixedOrigin.length + 1 + currentLang.length + 1, // 1 - is for slash
    indexEnd,
  );
  let search = '';
  if (prevQuery) {
    search = `${fullQuery ? '&' : '?'}${prevQuery}`;
  } else if (hasSearchParams) {
    const searchString = window.location.href.substring(window.location.href.indexOf('?') + 1);
    search = `${fullQuery ? '&' : '?'}${searchString}`;
  }
  /** if page was refreshed when url is not home or unwanted redirect to home */
  if (window.location.href.includes(prefixedOrigin) || (window.location.pathname === '/' && prevPath)) {
    iframeUrl = url + path + fullQuery + search;
  }

  if (prevMountedUrl === iframeUrl) return;
  prevMountedUrl = iframeUrl;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('src', iframeUrl);
  iframe.setAttribute('name', 'target');
  iframe.setAttribute('onload', onLoadCallback);

  const props = { ...defaultAttributes, ...attributes };
  Object.entries(props).forEach(([name, value]) => {
    iframe.setAttribute(name, value);
  });

  try {
    if (props.id && document.getElementById(props.id)) {
      document.getElementById(props.id).setAttribute('src', iframeUrl);
    } else {
      document.getElementById(id).append(iframe);
    }
  } catch (e) {
    console.error(e);
  }

  postMessage({ path: '/' + path || '/' }, 'iframe-navigation');

  return iframe;
};

const messagePubSub = {
  messages: new Map(),
  subscribers: new Map(),
  subscribe: (event, callback) => {
    messagePubSub.subscribers.set(event, callback);
    return {
      unsubscribe: () => {
        messagePubSub.subscribers.delete(event);
      },
    };
  },
  notifySubscribers: (event, data) => {
    const subscriberCallback = messagePubSub.subscribers.get(event);
    if (subscriberCallback) {
      subscriberCallback(data);
    }
  },
};

window.addEventListener('message', ({ data }) => {
  if (!data.type) return;
  messagePubSub.notifySubscribers(data.type, data);
});

messagePubSub.subscribe('navigation', (data) => {
  const { path } = data;
  if (
    configuration.isNavigationCaptureDisabled ||
    !path ||
    path === '/' ||
    path === `/${currentLang}/` ||
    configuration.blacklistedRoutes.includes(path)
  ) {
    return;
  }
  let query = '';
  if (data.query instanceof Object && Object.keys(data.query).length !== 0) {
    query = new URLSearchParams(data.query);
    query.delete('jwt');
    if (query.toString().length) {
      query = '?' + query.toString();
    }
  }

  window.history.replaceState(
    null,
    document.title,
    `${window.location.origin}/${configuration.urlPrefix}/${currentLang}${path}${query}`,
  );
  module.setData({path: `${path}`.substring(1)});
  module.setData({query: `${query}`.substring(1)});
});

const module = {
  init: ({
    languages,
    prefix = 'sports',
    blacklistedRoutes,
    isNavigationCaptureDisabled = false,
  }) => {
    configuration.languages = languages;
    configuration.urlPrefix = prefix;
    configuration.blacklistedRoutes =
      configuration.blacklistedRoutes || blacklistedRoutes;
    configuration.isNavigationCaptureDisabled = isNavigationCaptureDisabled;
    return module;
  },
  mount,
  on: (event, callback) => {
    const { unsubscribe } = messagePubSub.subscribe(event, callback);
    return {
      off: unsubscribe,
    };
  },
  emit: (data, type) => {
    postMessage(data, type);
  },
  helpers: {
    logout: () => module.emit({ logout: true }),
  },
  setData: (data) => {
    for (const key in data) {
      module.store[key] = data[key];
    }
  },
  getData: (dataName) => module.store[dataName],
  store: {},
};

export default module;
